import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AppProvider } from "@/lib/AppContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import ScrollManager from "@/components/ScrollManager";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import CarDetail from "@/pages/CarDetail";
import Configurator from "@/pages/Configurator";
import Services from "@/pages/Services";
import Reviews from "@/pages/Reviews";
import About from "@/pages/About";
import Contacts from "@/pages/Contacts";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";
import AdminPanel from "@/pages/AdminPanel";
import "@/App.css";

export default function App() {
  return (
    <HelmetProvider>
      <AppProvider>
        <BrowserRouter>
          <ScrollManager />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/cars/:slug" element={<CarDetail />} />
              <Route path="/configurator" element={<Configurator />} />
              <Route path="/services" element={<Services />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/administrator-panel" element={<AdminPanel />} />
          </Routes>
          <Toaster position="top-right" />
        </BrowserRouter>
      </AppProvider>
    </HelmetProvider>
  );
}
